// Gets a row parent with "has-background-image" class and attempts to set a background
// color of its ::after element (a paper-like svg). The color gets taken from the previous

import { ThemeIds } from '../util/util';

// row parent sibling.
function SetSvgColor() {
  const rowParents = document.getElementsByClassName('row-parent');

  if (!rowParents) {
    return;
  }

  const rowArray = Array.from(rowParents);

  rowArray.forEach((row, i) => {
    if (row.classList.contains('has-background-image')) {
      const sibling = rowArray[i - 1];
      const color = window.getComputedStyle(sibling).backgroundColor;

      if (color) {
        (row as HTMLDivElement).style.backgroundColor = color;
      }
    }
  });
}

// Adds classes to row parent elements based on whether their adjacent siblings have the class 'has-background-color'.
// These classes are used to add graphic pseudo-elements and to handle margins.
function determineGraphics() {
  const rowParents = document.getElementsByClassName('row-parent');
  const hasBgColor = 'has-background-color';
  const hasBgImg = 'has-background-image';

  const hasGraphic = (element: Element | null) => {
    return element && (element.classList.contains(hasBgColor) || element.classList.contains(hasBgImg));
  };

  for (const row of Array.from(rowParents)) {
    const hasBackground = hasGraphic(row);
    const prevRow = row.previousElementSibling;
    const nextRow = row.nextElementSibling;

    if (hasBackground) {
      let cssClass = 'top-bottom-graphic';

      if (hasGraphic(prevRow) && hasGraphic(nextRow)) {
        cssClass = 'no-graphic';
      } else if (hasGraphic(prevRow)) {
        if (!nextRow) {
          cssClass = 'no-graphic';
        }
        else {
          cssClass = 'bottom-graphic';
        }
      } else if (hasGraphic(nextRow)) {
        cssClass = 'top-graphic';
      }

      row.classList.add(cssClass);
    }
  }
}

// Handles the number of background SVGs depending on the screen size.
function updateSvgAmount() {
  const bgSvg = document.getElementById('bg-svg');
  const svgContainer = document.getElementById('bg-svg-container');
  const main = document.querySelector('main');

  if (bgSvg && svgContainer && main) {
    const clone = bgSvg.cloneNode(true);
    let svgAmount = Math.ceil(main.clientHeight / (bgSvg.clientHeight));

    while (svgContainer.firstChild) {
      svgContainer.removeChild(svgContainer.firstChild);
    }

    for (let i = 0; i < svgAmount; i++) {
      svgContainer.appendChild(clone.cloneNode(true));
    }
  }
}

window.addEventListener('load', function() {
  updateSvgAmount();
});

window.addEventListener('resize', function() {
  updateSvgAmount();
});

export default function GridFunctions(theme: ThemeIds) {
  if (theme === ThemeIds.raw) {
    SetSvgColor();
    return;
  }

  if (theme === ThemeIds.exclusive) {
    determineGraphics();
    updateSvgAmount();
  }
}
